module.exports = __webpack_public_path__ + "img/waf.f1535e9.webp";